import React from 'react';
import PropTypes from 'prop-types';

const UiExpandContentPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16.5 6C16.224 6 16 6.224 16 6.5V9.5C16 9.777 16.224 10 16.5 10H21C21.552 10 22 10.448 22 11V15.5C22 15.776 22.224 16 22.5 16H25.5C25.776 16 26 15.776 26 15.5V7.5C26 6.672 25.329 6 24.5 6H16.5ZM6.5 16C6.224 16 6 16.224 6 16.5V24.5C6 25.328 6.671 26 7.5 26H15.5C15.776 26 16 25.776 16 25.5V22.5C16 22.224 15.776 22 15.5 22H11C10.448 22 10 21.553 10 21V16.5C10 16.224 9.776 16 9.5 16H6.5Z"
    />
  );
};

UiExpandContentPath.propTypes = {
  fill: PropTypes.string,
};

export default UiExpandContentPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-expand-content.jsx